// 错误码与菜单相关更新
let myClueName = window.localStorage.getItem('isCluePoolName');

export const errorCode = {
  203: '用户名未注册',
  400: '请求参数有误',
  401: '用户未登录',
  403: '无效的授权',
  404: '资源未找到',
  405: '请求方式不正确',
  406: '请求参数有误',
  407: 'PIN时间戳和服务器时间误差超过10分钟',
  408: 'API SECRECT验证失败',
  409: '缺少 X-AK-KEY 或者 X-AK-PIN 或 X-AK-TS 请求头',
  410: 'API_KEY 不存在',
  413: '上传的图片不能大于5M',
  500: '服务器错误',
  5001: '关键字不合法，太短，需大于等于4',
  5002: '省份代码不合法',
  1000: '账户已过期',
  1001: '请求次数超限',
  1002: '无权限访问',
  1003: '并发超过限制',
  1004: '账号格式不正确',
  1005: '验证码未被正确识别，请重新操作',
  1006: '用户未注册',
  1060: '邮箱地址无效，请输入正确的邮箱',
  1061: '此邮箱未注册',
  1062: '账户状态异常，无法重置密码，请联系管理员。',
  1007: '激活地址已经失效，请联系管理员!',
  1008: '已存在该菜单配置页',
  1009: '验证码失效',
  1010: '用户名或密码错误',
  1012: '没有剩余额度',
  1013: '不能重复添加该企业监控或收藏',
  1014: '你监控的企业业务有效时间已过期',
  1015: '该企业已被监控，请先取消监控！',
  1016: '默认分组，不可新增和修改',
  1026: '短信验证码错误',
  1027: '原密码错误',
  1028: '手机号已存在，请更换手机号',
  1029: '短信验证码已过期',
  1030: '监控失败，账户余额不足！',
  1031: '已存在此名称的分组',
  1032: '请输入企业名称',
  1033: '不能删除当前登录帐户',
  1034: '账户已激活',
  1035: '事件不存在',
  1036: '最大支持500条',
  1037: '用户不存在，不能修改密码！',
  1038: '密码不能为空',
  1039: '密码必须大于等于6位',
  1040: '未激活，不能重置密码',
  1041: '不能删除当前登录账户',
  1042: '邮箱已存在，不能重复添加',
  1043: '手机号已存在，不能重复添加',
  1044: '企业名称长度不能大于50',
  1045: '未激活，不能进行操作',
  1046: '渠道剩余授信额度不足，充值失败',
  1047: ' 订阅时长不合法',
  1048: '账户不合法',
  1049: '渠道名称已存在',
  1050: '该企业没有被监控，不能取消',
  1051: '已加入监控',
  1052: '已加入收藏',
  1053: 'IP白名单格式不正确',
  1054: '上传附件格式错误',
  1055: '充值点数不合法',
  1056: '授信额度不合法',
  1058: '请求的路由参数格式不正确',
  1059: '关键字不合法，太短，需大于等于4',
  1065: '没有登录权限',
  1066: '用户名或密码错误',
  1067: '用户需要重新设置密码',
  1201: '不存在的临时授权码',
  6000: '公海名称最多支持10个字符',
  6001: '公海数量已达上限，无法创建',
  6002: '公海名称已存在',
  6003: '公海名称不存在',
  6004: '更新公海失败',
  6005: '今日查看次数已达上限',
  6006: `${myClueName ? myClueName : '您的线索池'}已满，暂时无法添加${
    myClueName ? '' : '线索'
  }，请清理后重试。`,
  6007: '该线索已被其他用户处理',
  6008: '公海正在创建或者更新中',
  6009: '公海已满',
  6010: '此条件下已无更多的数据，您可以重新组合公海',
  6011: '添加的线索没有联系方式',
  6012: '距离更新还需消耗100/100条线索,请继续消耗',
  6013: '公海关键词已存在',
  6014: '月授信额度达到上限',
  6015: '子账户数已达上限',
  6016: '该账户已被冻结',
  6017: '该账户的上级账户已失效或冻结',
  6018: '不可低于账户已使用的授信额度!',
  6019: '已添加线索',
  6020: '账户有效期不足，无法开通套餐，请联系管理员续期',
  6021: '订单状态已改变，请确认后重新操作',
  6022: '超过上级分销授信额度，请重新输入',
  6023: '无法注销！请先注销该账户下的所有账户',
  6027: '流程失效，请重新认证您的邮箱和手机号码',
  6028: '号码错误。',
  6029: '无效的授权',
  6031: '自定义联系方式不存在',
  6038: '已超过子账户上限，无法增加',
  6039: '附加月数不能超过有效期，请重新选择',
  6040: '日查看已经超过上限，无法增加',
  6106: '操作过于频繁，请稍后重试',
  6111: '手机号码不合法',
  6115: '套餐名称不正确',
  6116: '升级套餐子账户数不能比现有子账户数小',
  6117: '发送失败',
  6118: '60秒内，不能重复获取验证码',
  6124: '任务中心超过额度，无法增加',
  6125: '任务中心未开启',
  6126: '账户已经被其他人登录',
  6127: '登录过期',
  6128: '滑块验证出错，请重试',
  6041: '无可操作的线索',

  1300: '您的管理员还未为您配置可使用的账户，请联系管理员为您设置。',
  1306: '已达更新次数上限（3次/h），请稍后重试',
  1311: '该用户已存在',
  1307: '账套剩余账户不足',
  1204: '您的钉钉账号不存在于该企业架构中，请联系管理员处理',
  1207: '找不到该用户',

  5000: '该板块正在执行任务，请稍后再试',
  5021: '未知错误',
  5023: '访问出错',
  5032: '当前用户已冻结或未激活',
  5104: '用户名或密码错误',

  9999: '线索状态已改变，请重新选择', //自定义提示
  6129: '任务额度不合法', //分销用户设置用户额度

  1069: '您的账户被停用，请联系您的销售客服',
  1070: '您的账户被停用，请联系您的上级账户',
  1071: '主账户下当前已启用的子账户已达上限',

  1080: '生成验证码错误',
  1081: '验证码不正确',
  1082: '图片验证码已过期',
  1083: '图片验证码失效',
  1084: '验证码非法',
  1085: '验证码超过尝试次数',

  1087: '当前账户余额不足，请及时充值',
  1208: '邮箱已被使用，请更换',
  1209: '手机号已被使用，请更换',
  1089: '套餐不可降级',
  6130: '未开启流量包使用权限',
  6131: '流量包数量只能是1到100',
  6132: '账号信息异常',
  6133: '流量包额度超过最大值',
  6134: '个人使用额度为0到50000',
  6135: '外呼计划缺失，请补充后再次提交',
  5036: '参数错误',
  5037: '测试套餐不能续期，请升级为正式套餐后操作！',
  5038: '当前套餐已下架，请重新选择',
  1090: '账号已被删除',
  6136: '主账号不可变更为个人账号',
  5039: '无权限导出'
};



// WEBPACK FOOTER //
// ./src/common/errorCode.js